export const articleQueryKeys = {
	article: (id: number) => ["article-v2", id] as const,
};
